import React, { useEffect, useMemo, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { baseUrl } from "../../utils/baseUrl";
import axios from "axios";
import {
  ICountry,
  IMeansOfIdentification,
  IReligion,
  ISocialMediaPlatform,
} from "../../models/IEnums.model";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../utils/localStorage";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import * as toast from "../../utils/makeToast";
import IdCardSample from "../IdCardSample";
import {
  accountOpeningSteps,
  idValidation,
  nextOfKinRelationships,
} from "../../utils/constants";
import OtpDialogModal from "../OtpDialogModal";
import Loader from "../Loader";
import Modal from "../Modal";
import { statesInNigeria } from "../../utils/constants";
import { IUDateUserUpdate } from "../../models/IAccount";
import CustomDropdown from "../CustomDropdown";
import {
  extractValuesFromObj,
  returnInputErrorMessage,
  returnLgaError,
} from "../../utils/helpers";
import apiHooks from "../../customHooks/apis";
import CustomInputField from "../CustomInputField/CustomInputField";
import useAutoUpdateAddress from "../../customHooks/useAutoUpdateAddress";

interface FormValues {
  firstName: string;
  secondName: string;
  lastName: string;
  dateOfBirth: string;
  phoneNumber: string;
  emailAddress: string;
  gender: string;
  houseNumber: string;
  streetName: string;
  areaState: string;
  nearestBustopLandmark: string;
  address: string;
  religion: string;
  selfEmployementInformation: number;
  occupation: number;
  nextOfKin: string;
  referralCode: string;
  bvn: string;
  socialMediaId: number;
  socialMediaHandle: string;
  termsCondition: boolean;
  town: string;
  localGovernment: string;
  branchOfDomiciliation: number;
  relationshipOfNextOfKin: string;
}
function UpdateDetailMobiciliaryCurrentDialog(props: any) {
  const dispatch = useDispatch();
  const {
    useGetBranchCodes,
    useGetOccupations,
    useGetEmploymentInfo,
    useUserDetails,
    useGetReligions,
  } = apiHooks;
  const { userDetails, handleUpdateUserDetails } = useUserDetails();
  const { religions, getSelectedReligion } = useGetReligions();
  const { branches, getSelectedBranch } = useGetBranchCodes();
  const { occupations, getSelectedOccupation } = useGetOccupations();
  const { employmentInfo, getSelectedEmployment } = useGetEmploymentInfo();
  const [updating, setUpdating] = useState(false);
  const [meansOfIdentification, setMeansOfIdentification] = useState<
    IMeansOfIdentification[]
  >([]);
  // const [employmentInfos, setEmploymentInfos] = useState<IEmploymentInfo[]>([]);
  const [countries, setCountries] = useState<ICountry[]>([]);
  const [idCardtype, setIdCardType] = useState<any>(1);
  // const [idCardNumberLength, setIdCardNumberLength] = useState<number | any>(idValidation.find(x => x.id == 1)?.length)
  const [idCardNumberLength, setIdCardNumberLength] = useState<number | any>(
    11
  );
  const [socialMediaPlatforms, setSocialMediaPlatforms] = useState<
    ISocialMediaPlatform[]
  >([]);
  const storedValues = sessionStorage.getItem("formData");
  const parsedValues: Partial<FormValues> = storedValues
    ? JSON.parse(storedValues)
    : {};
  // const [userDetails, setUserDetails] = useState(
  //   getLocalStorageItem("userDetails")
  // );
  // const [todaysDate, setTodaysDate] = useState<any>(
  //   new Date().toISOString().split("T")[0]
  // );

  const [storedUserDataIdCard, setStoredUserDataIdCard] = useState<any>();

  const [ninModalOpen, setNinModalOpen] = useState(false);
  const [otpLoader, setOtpLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showNinModal, setShowNinModal] = useState(false);
  const [showBvnMiddleEmptyModal, setShowBvnMiddleEmptyModal] = useState(false);
  const [showNinMiddleEmptyModal, setShowNinMiddleEmptyModal] = useState(false);
  const [showfirstNameModal, setShowfirstNameModal] = useState(false);
  const [showmiddleNameModal, setShowmiddleNameModal] = useState(false);
  // const [branchData, setBranch] = useState([]);
  const [showlastNameModal, setShowlastNameModal] = useState(false);
  const [showGenderNameModal, setShowGenderNameModal] = useState(false);
  const [showDobNameModal, setShowDoBNameModal] = useState(false);

  const [genders, SetGenders] = useState<{ name: string; value: string }[]>([
    { name: "Male", value: "M" },
    { name: "Female", value: "F" },
  ]);
  const goToStep = (step: any) => {
    dispatch(setAccountOpeningStep(step));
  };

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault(); // Prevent input of non-numeric characters
    }
  };

  const formik = useFormik<FormValues>({
    initialValues: {
      firstName: "",
      secondName: "",
      lastName: "",
      dateOfBirth: "",
      phoneNumber: "",
      emailAddress: "",
      houseNumber: "",
      streetName: "",
      areaState: "",
      nearestBustopLandmark: "",
      address: "",
      religion: "",
      selfEmployementInformation: -1,
      occupation: -1,
      nextOfKin: "",
      referralCode: "",
      socialMediaId: -1,
      socialMediaHandle: "",
      gender: "",
      localGovernment: "",
      town: "",
      relationshipOfNextOfKin: "",
      branchOfDomiciliation: -1,
      bvn: "",
      termsCondition: false,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      secondName: Yup.string(),
      lastName: Yup.string().required("Last name is required"),
      dateOfBirth: Yup.string().required("Date of birth is required"),
      phoneNumber: Yup.string().required("Phone number is required"),

      emailAddress: Yup.string().email("Invalid email"),
      gender: Yup.string().required("Please select a gender"),
      houseNumber: Yup.string().required("House number is required"),
      streetName: Yup.string().required("Street name is required"),
      areaState: Yup.string().required("Area is required"),
      nearestBustopLandmark: Yup.string().required(
        "Nearest bus stop is required"
      ),
      address: Yup.string()
        .max(50, "Address should not be more than 50 characters")
        .required("Address is required"),
      religion: Yup.string().required("Religion is required"),

      selfEmployementInformation: Yup.number()
        .min(0, "Employment information is required")
        .required("Employment information is required"),

      occupation: Yup.number()
        .min(0, "Occupation is required")
        .required("Occupation is required"),

      nextOfKin: Yup.string().required("Next of kin is required"),
      referralCode: Yup.string(),
      bvn: Yup.string().required("BVN is required"),
      socialMediaId: Yup.number(),
      socialMediaHandle: Yup.string(),
      termsCondition: Yup.boolean().oneOf(
        [true],
        "You must accept the terms and conditions"
      ),
      town: Yup.string().required("Town is required"),
      localGovernment: Yup.string().required(
        "Local Government Area is required"
      ),

      branchOfDomiciliation: Yup.number()
        .min(0, "Branch of domiciliation is required")
        .required("Branch of domiciliation is required"),

      relationshipOfNextOfKin: Yup.string().required(
        "Relationship to Next Of Kin is required"
      ),
    }),
    onSubmit: (values) => updateDetails(values),
  });
  useAutoUpdateAddress<FormValues>({
    formik,
    fieldNames: [
      "houseNumber",
      "streetName",
      "nearestBustopLandmark",
      "areaState",
    ],
  });
  // const handleBlurAddressChild = () => {
  //   formik.setValues({
  //     ...formik.values,
  //     address: `${formik.values?.houseNumber} ${formik.values?.streetName} ${formik.values?.nearestBustopLandmark} ${formik.values?.areaState}`,
  //   });
  // };

  const sendOtp = () => {
    setOtpLoader(true);
    let resendOtpPayload = {
      phoneNumber: userDetails.phoneNumber,
      customerName: `${userDetails.firstName} ${userDetails.lastName}`,
      bvn: userDetails.bvn,
    };

    axios
      .post(`${baseUrl}Authentication/SendOTP`, resendOtpPayload)
      .then((response) => {
        setNinModalOpen(true);
        setOtpLoader(false);
      })
      .catch((err) => {
        setOtpLoader(false);
        toast.errorToast("something went wrong");
      });
  };

  // let userInfo = getLocalStorageItem("userDetails") || {};

  const updateDetails = (values: FormValues) => {
    setUpdating(true);
    const updateDetailsPayload: FormValues = {
      ...values,
      religion: String(values.religion),
    };
    // let updateDetailsPayload: FormValues = {
    //   religion: values.religion,
    //   occupation: +values.occupation,
    //   // identityCardType: +idCardtype,
    //   selfEmployementInformation: +values.selfEmployementInformation,
    //   socialMediaId: +values.socialMediaId,
    //   // id: 0,
    //   // passport: "",
    //   bvn: userDetails.bvn,
    //   termsCondition: true,
    //   firstName: values?.firstName,
    //   secondName: values?.secondName,
    //   lastName: values.lastName,
    //   dateOfBirth: values?.dateOfBirth,
    //   phoneNumber: values?.phoneNumber,
    //   emailAddress: values?.emailAddress,
    //   gender: values?.gender,
    //   houseNumber: values?.houseNumber,
    //   streetName: values?.streetName,
    //   areaState: values?.areaState,
    //   nearestBustopLandmark: "",
    //   address: values?.address,
    //   nextOfKin: values?.nextOfKin,
    //   referralCode: values?.referralCode,
    //   socialMediaHandle: values?.socialMediaHandle,
    //   town: values?.town,
    //   localGovernment: "",
    //   branchOfDomiciliation: values?.branchOfDomiciliation
    //     ? Number(values?.branchOfDomiciliation)
    //     : 0,
    //   relationshipOfNextOfKin: values?.relationshipOfNextOfKin,
    // };

    // return
    // setLocalStorageItem(
    //   "update-details-page-user-data",
    //   JSON.stringify(updateDetailsPayload)
    // );
    axios
      .post(
        `${baseUrl}DomiciliaryCurrent/DomiciliaryCurrentDetails`,
        updateDetailsPayload
      )
      .then((response) => {
        const { isSuccess, message } = response?.data || {};
        if (!isSuccess) {
          return toast.errorToast(message);
        }
        toast.successToast(message);
        handleUpdateUserDetails({
          ...values,
          uploadid: response?.data?.obj?.id,
          email: values.emailAddress,
        });
        // setLocalStorageItem(
        //   "userDetails",
        //   JSON.stringify({
        //     ...userInfo,
        //     uploadid: response?.data?.obj?.id,
        //   })
        // );
        dispatch(setAccountOpeningStep(accountOpeningSteps.addReference));
        if (formik.values.emailAddress?.length == 0) {
          // setOtpLoader(true);
          // let ninPayload = {
          //   id: formik.values.idCardNumber,
          //   isSubjectConsent: true,
          //   phoneNumber: formik.values.phoneNumber,
          //   bvnPhoneNumber: userDetails.phoneNumber,
          //   bvnFirstName: userInfo.firstName,
          //   bvnLastName: userInfo.lastName,
          //   bvnMiddleName: userInfo.middleName,
          //   bvnDateOfBirth: userInfo.dateOfBirth,
          //   bvnGender: userInfo.gender,
          //   bvn: userInfo.bvn,
          // };
          // axios
          //   .post(`${baseUrl}Authentication/ValidateNIN`, ninPayload)
          //   .then((response) => {
          //
          //     if (response.data.success) {
          //       toast.successToast("NIN Validated Successfully");
          //       dispatch(setAccountOpeningStep("document-upload"));
          //     } else if (
          //       response.data.message ===
          //       "Bvn phoneNumber does not match with NIN phoneNumber"
          //     ) {
          //       setShowNinModal(true);
          //       setShowModal(true);
          //     } else if (response.data.message === "Bvn middleName is empty") {
          //       setShowBvnMiddleEmptyModal(true);
          //       setShowModal(true);
          //     } else if (response.data.message === "NIN middleName is empty") {
          //       setShowNinMiddleEmptyModal(true);
          //       setShowModal(true);
          //     } else if (
          //       response.data.message ===
          //       "FirstName does not match for BVN and NIN"
          //     ) {
          //       setShowfirstNameModal(true);
          //       setShowModal(true);
          //     } else if (
          //       response.data.message ===
          //       "MiddleName does not match for BVN and NIN"
          //     ) {
          //       setShowmiddleNameModal(true);
          //       setShowModal(true);
          //     } else if (
          //       response.data.message ===
          //       "LastName does not match for BVN and NIN"
          //     ) {
          //       setShowlastNameModal(true);
          //       setShowModal(true);
          //     } else if (
          //       response.data.message ===
          //       "Gender does not match for BVN and NIN"
          //     ) {
          //       setShowGenderNameModal(true);
          //       setShowModal(true);
          //     } else if (
          //       response.data.message ===
          //       "Date Of Birth does not match for BVN and NIN"
          //     ) {
          //       setShowDoBNameModal(true);
          //       setShowModal(true);
          //     } else {
          //       toast.errorToast("Please Input a Valid NIN");
          //     }
          //     setOtpLoader(false);
          //   })
          //   .catch((err) => {
          //     toast.errorToast("Invalid NIN. Please Input a Valid NIN");
          //
          //     setOtpLoader(false);
          //   });
          // setOtpLoader(false);
        } else {
          // checkEmailAndValidateNIN();
        }
        // setUpdating(false);
      })
      .catch((err) => {
        // setUpdating(false);
        console.error({ err });

        toast.errorToast(
          err
            ? err?.response?.data?.title
              ? err?.response?.data?.title
              : err?.response?.data?.message
            : "Something went wrong"
        );
      })
      .finally(() => {
        setUpdating(false);
        setOtpLoader(false);
      });
  };

  // const checkEmailAndValidateNIN = () => {
  //   const CheckAccountExistenceByContactPayload = {
  //     email: formik.values.emailAddress,
  //     phoneNumber: formik.values.phoneNumber,
  //   };
  //   axios
  //     .post(
  //       `${baseUrl}Authentication/CheckAccountExistenceByContact`,
  //       CheckAccountExistenceByContactPayload
  //     )
  //     .then((response) => {
  //       if (response?.data?.length == 0) {
  //         setOtpLoader(true);
  //         let ninPayload = {
  //           // id: formik.values.idCardNumber,
  //           isSubjectConsent: true,

  //           phoneNumber: formik.values.phoneNumber,
  //           bvnPhoneNumber: userDetails.phoneNumber,
  //           bvnFirstName: userInfo.firstName,
  //           bvnLastName: userInfo.lastName,
  //           bvnMiddleName: userInfo.middleName,
  //           bvnDateOfBirth: userInfo.dateOfBirth,
  //           bvnGender: userInfo.gender,
  //           bvn: userInfo.bvn,
  //         };
  //         axios
  //           .post(`${baseUrl}Authentication/ValidateNIN`, ninPayload)
  //           .then((response) => {
  //             if (response.data.success) {
  //               toast.successToast("NIN Validated Successfully");
  //               dispatch(setAccountOpeningStep("document-upload"));
  //             } else if (
  //               response.data.message ===
  //               "Bvn phoneNumber does not match with NIN phoneNumber"
  //             ) {
  //               setShowNinModal(true);
  //               setShowModal(true);
  //             } else if (response.data.message === "Bvn middleName is empty") {
  //               setShowBvnMiddleEmptyModal(true);
  //               setShowModal(true);
  //             } else if (response.data.message === "NIN middleName is empty") {
  //               setShowNinMiddleEmptyModal(true);
  //               setShowModal(true);
  //             } else if (
  //               response.data.message ===
  //               "FirstName does not match for BVN and NIN"
  //             ) {
  //               setShowfirstNameModal(true);
  //               setShowModal(true);
  //             } else if (
  //               response.data.message ===
  //               "MiddleName does not match for BVN and NIN"
  //             ) {
  //               setShowmiddleNameModal(true);
  //               setShowModal(true);
  //             } else if (
  //               response.data.message ===
  //               "LastName does not match for BVN and NIN"
  //             ) {
  //               setShowlastNameModal(true);
  //               setShowModal(true);
  //             } else if (
  //               response.data.message ===
  //               "Gender does not match for BVN and NIN"
  //             ) {
  //               setShowGenderNameModal(true);
  //               setShowModal(true);
  //             } else if (
  //               response.data.message ===
  //               "Date Of Birth does not match for BVN and NIN"
  //             ) {
  //               setShowDoBNameModal(true);
  //               setShowModal(true);
  //             } else {
  //               toast.errorToast("Please Input a Valid NIN");
  //             }
  //             setOtpLoader(false);
  //           })
  //           .catch((err) => {
  //             toast.errorToast("Invalid NIN. Please Input a Valid NIN");

  //             setOtpLoader(false);
  //           });
  //       } else {
  //         toast.errorToast(
  //           "Account already exist for this email address or phone number"
  //         );
  //         setOtpLoader(false);
  //       }
  //     })
  //     .catch((err) => {
  //       setOtpLoader(false);
  //       toast.errorToast(
  //         "Account already exist for this email address or phone number"
  //       );
  //     });
  // };

  // const getOccupations = () => {
  //   axios
  //     .get(`${baseUrl}Enum/Occupation`)
  //     .then((response) => {
  //       setOccupations(response.data);
  //     })
  //     .catch((err) => {});
  // };

  // const getEmploymentInfo = () => {
  //   axios
  //     .get(`${baseUrl}Enum/EmployementInfo`)
  //     .then((response) => {
  //       setEmploymentInfos(response.data);
  //     })
  //     .catch((err) => {});
  // };

  const getMeansOfIdentification = () => {
    axios
      .get(`${baseUrl}Enum/MeansOfIdentification`)
      .then((response) => {
        setMeansOfIdentification(response.data);
      })
      .catch((err) => {});
  };

  const getCountries = () => {
    axios
      .get(`${baseUrl}Enum/Country`)
      .then((response) => {
        let nigeria = response?.data.find(
          (x) => x.lonG_DESC_ENG.toLowerCase() === "nigeria"
        );
        let otherCountries = response?.data.filter(
          (x) => x.lonG_DESC_ENG.toLowerCase() !== "nigeria"
        );
        let countries = [nigeria, ...otherCountries];
        setCountries(countries);
      })
      .catch((err) => {});
  };

  const getSocialMediaPlatforms = () => {
    axios
      .get(`${baseUrl}Enum/SocialMedia`)
      .then((response) => {
        setSocialMediaPlatforms(response.data);
      })
      .catch((err) => {});
  };

  // const fetchBranches = async () => {
  //   try {
  //     const response = await services.GetBranches();
  //     setBranch(response);
  //   } catch (err) {}
  // };
  const handleSetIdCardType = (id: any, idCardNumber?: string) => {
    setIdCardNumberLength(idValidation.find((x) => x.id == id)?.length);
    setIdCardType(id);
    formik.resetForm({
      values: { ...formik.values },
    });
  };

  // const getExistingDetails = () => {
  //   if (localStorage.getItem("previous-screen") === "document-upload") {
  //     // axios.get(`${baseUrl}CurrentAccount/CurrentExistingDetails?bvn=${userDetails.bvn}`)
  //     //   .then((response) => {
  //     //     let userData = response?.data
  //     let userData = getLocalStorageItem("update-details-page-user-data");
  //     formik.initialValues.emailAddress = userData?.emailAddress;
  //     formik.initialValues.houseNumber = userData?.houseNumber;
  //     formik.initialValues.streetName = userData?.streetName;
  //     formik.initialValues.areaState = userData?.areaState;
  //     formik.initialValues.nearestBustopLandmark =
  //       userData?.nearestBustopLandmark;
  //     formik.initialValues.address = userData?.address;
  //     formik.initialValues.occupation = userData?.occupation;
  //     formik.initialValues.religion = userData?.religion;
  //     formik.initialValues.selfEmployementInformation =
  //       userData?.selfEmploymentInformation;
  //     formik.initialValues.referralCode = userData?.referralCode;
  //     // formik.initialValues.nationality = userData?.nationality;
  //     // formik.initialValues.identityCardType = userData?.identityCardType;
  //     // formik.initialValues.idCardNumber = userData?.idCardNumber;
  //     // formik.initialValues.issueDate = userData?.issueDate;
  //     // formik.initialValues.expiryDate = userData?.expiryDate;
  //     formik.initialValues.nextOfKin = userData?.nextOfKin;
  //     handleSetIdCardType(userData?.identityCardType, userData?.idCardNumber);
  //     setStoredUserDataIdCard(userData?.identityCardType);
  //     //   })
  //     //   .catch((err) => {
  //     //
  //     //   })
  //   }
  //   localStorage.removeItem("previous-screen");
  // };

  useEffect(() => {
    getMeansOfIdentification();
    // getEmploymentInfo();
    getCountries();
    // fetchBranches();
    // getExistingDetails();
    getSocialMediaPlatforms();
  }, []);
  // useEffect(() => {
  //   sessionStorage.setItem("detail-current", JSON.stringify(formik.values));
  // }, [formik.values]);

  const [selectedState, setSelectedState] = useState("");
  const [lgas, setLgas] = useState([]);

  const handleStateChange = (event) => {
    const selected = event.target.value;
    setSelectedState(selected);

    const state = statesInNigeria.find((state) => state.name === selected);
    if (state) {
      setLgas(state.lgas);
    } else {
      setLgas([]);
    }

    formik.handleChange(event);
  };

  useEffect(() => {
    formik.setValues({
      ...formik.initialValues,
      ...extractValuesFromObj(formik.initialValues, userDetails),
      secondName: userDetails?.middleName || "",
      emailAddress: userDetails?.email || "",
      gender: (userDetails?.gender as string)?.[0]?.toUpperCase() || "",
    });
  }, [userDetails]);

  return (
    <div>
      {otpLoader && <Loader />}
      <Modal
        openModal={showModal && showNinModal}
        closeModal={() => setShowModal(false)}
        header="Mobile number MissMatch"
      />
      <Modal
        openModal={showModal && showfirstNameModal}
        closeModal={() => setShowModal(false)}
        header="First name does not match"
        paragraph="Hello Partner, the first name on your BVN does not match the one on your NIN. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the first name mismatch on your BVN/NIN has been resolved. "
      />
      <Modal
        openModal={showModal && showmiddleNameModal}
        closeModal={() => setShowModal(false)}
        header="Middle name mismatch"
        paragraph="The Middle name on your BVN and NIN does not match. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details."
      />
      <Modal
        openModal={showModal && showlastNameModal}
        closeModal={() => setShowModal(false)}
        header="Last name does not match"
        paragraph="Hi Partner, the Last name on your BVN and NIN does not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the last name mismatch on your BVN/NIN has been resolved."
      />
      <Modal
        openModal={showModal && showDobNameModal}
        closeModal={() => setShowModal(false)}
        header="Date of Birth does not match"
        paragraph="Hello Partner, the date of birth in your BVN and NIN records does not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the Date of birth mismatch on your BVN/NIN has been resolved. "
      />
      <Modal
        openModal={showModal && showGenderNameModal}
        closeModal={() => setShowModal(false)}
        header="Gender Mismatch/mismatch in gender information "
        paragraph="Hi Partner, the gender details on your BVN and NIN do not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the Gender mismatch on your BVN/NIN has been resolved.  "
      />

      <Modal
        openModal={showModal && showBvnMiddleEmptyModal}
        closeModal={() => setShowModal(false)}
        header="Middle name is Empty"
        paragraph="The Middle name on your BVN is empty. Kindly visit any branch of your BVN enrollment bank  to rectify your BVN details "
      />

      <Modal
        openModal={showModal && showNinMiddleEmptyModal}
        closeModal={() => setShowModal(false)}
        header="Middle name is empty"
        paragraph="The Middle name on your NIN is empty. Kindly visit  the NIMC office to rectify your NIN details."
      />
      <form onSubmit={formik.handleSubmit} className="update-details-form-body">
        <div className="card-body">
          <h4 className="card-title text-center pl-3 mt-4">Update details</h4>
          <p className="text-center pl-5 no-wrap">
            Hello{" "}
            <span className="font-weight-bold">
              <b>{userDetails.firstName},</b>{" "}
            </span>
            Welcome to The Alternative Bank
          </p>
          {/* <div className="bvn_val mb-4" id="fader">
            <img src={Icon_L} alt="" />
            <small className="sterling-grey-text ml-4 font-weight-bold">
              <b>Update your address and email if it has changed</b>
            </small>
          </div> */}
          <div className="row">
            {/* <div className="col-sm-4 mt-4">
              <small className="label_text">Photo</small>
              <div className="col-12 pic_upload3"></div>
            </div> */}

            <div className="col-sm-12z mt-4 pt-2 sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 sec">
                  <label htmlFor="firstname" className="label_text">
                    Firstname
                  </label>
                  <input
                    name="firstName"
                    value={userDetails.firstName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Tunde"
                    disabled
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="secondname" className="label_text">
                    Middle Name
                  </label>
                  <input
                    name="secondName"
                    value={userDetails.middleName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                    disabled
                  />
                </div>
              </div>
              <div className="row form-row mb-3">
                <div className="col-lg-6">
                  <label htmlFor="lastname" className="label_text">
                    Surname
                  </label>
                  <input
                    name="lastName"
                    value={userDetails.lastName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Aminah"
                    disabled
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="dateofbirth" className="label_text">
                    Date of birth
                  </label>
                  <input
                    name="dob"
                    value={userDetails.dateOfBirth}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="12-04-1989"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6 form-group">
                  <CustomDropdown
                    disabled={!!userDetails.gender}
                    required={!userDetails?.gender}
                    label="Gender"
                    name="gender"
                    onClickOption={formik.handleChange}
                    value={`${
                      (userDetails?.gender ||
                        formik.values.gender)?.[0]?.toLowerCase() === "f"
                        ? "Fem"
                        : "M"
                    }ale`}
                    placeholder="Select a gender"
                    options={genders}
                    formik={formik}
                    labelKey="name"
                    valueKey="value"
                    errorMessage={returnInputErrorMessage<FormValues>(
                      formik,
                      "gender"
                    )}
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="email" className="label_text">
                    Email address
                  </label>
                  <input
                    name="emailAddress"
                    onChange={formik.handleChange}
                    // disabled
                    value={formik.values.emailAddress}
                    type="email"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.emailAddress && formik.errors.emailAddress ? (
                    <small className="text-danger">
                      {typeof formik.errors.emailAddress === "string"
                        ? formik.errors.emailAddress
                        : JSON.stringify(formik.errors.emailAddress)}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="row"></div>
          <label
            htmlFor="residentialaddress"
            className="label_text my-2 mt-4 font-weight-bold"
            style={{ display: "block", textAlign: "center" }}
          >
            <b>Residential address</b>
          </label>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="housenumber" className="label_text">
                    House number<span className="text-danger">*</span>
                  </label>
                  <input
                    name="houseNumber"
                    onChange={formik.handleChange}
                    value={formik.values.houseNumber}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    onKeyPress={handleKeyPress}
                    className="form-control bg-white border-dark"
                    placeholder="eg. 12"
                    pattern="[0-9]*" // This pattern allows only numeric characters
                  />
                  {formik.touched.houseNumber && formik.errors.houseNumber ? (
                    <small className="text-danger">
                      {formik.errors.houseNumber}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Street name<span className="text-danger">*</span>
                  </label>
                  <input
                    name="streetName"
                    onChange={formik.handleChange}
                    value={formik.values.streetName}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Bode Thomas"
                  />
                  {formik.touched.streetName && formik.errors.streetName ? (
                    <small className="text-danger">
                      {formik.errors.streetName}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col sec">
              <div className="row form-row align-items-end mb-3">
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Nearest bus-top/landmark
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    name="nearestBustopLandmark"
                    onChange={formik.handleChange}
                    value={formik.values.nearestBustopLandmark}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Masha round about"
                  />
                  {formik.touched.nearestBustopLandmark &&
                  formik.errors.nearestBustopLandmark ? (
                    <small className="text-danger">
                      {formik.errors.nearestBustopLandmark}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    required
                    label="State"
                    name="areaState"
                    onClickOption={handleStateChange}
                    value={formik.values.areaState}
                    // onBlur={handleBlurAddressChild}
                    options={statesInNigeria}
                    labelKey="name"
                    valueKey="name"
                    errorMessage={returnInputErrorMessage<FormValues>(
                      formik,
                      "areaState"
                    )}
                    formik={formik}
                  />
                  {/* <label htmlFor="housenumber" className="label_text">
                    <span className="text-danger">*</span>
                  </label> */}
                  {/* <select
                    //   onChange={formik.handleChange}

                    className="form-control border-dark"
                    style={{
                      padding: "13px",
                    }}
                  >
                    <option value="">Select state</option>
                    {statesInNigeria.map((state: any) => {
                      return (
                        <option key={state.name} value={state.name}>
                          {state.name}
                        </option>
                      );
                    })}
                  </select> */}
                  {/* {formik.touched.areaState && formik.errors.areaState ? (
                    <small className="text-danger">
                      {formik.errors.areaState}
                    </small>
                  ) : null} */}
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-2">
            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Town <span className="text-danger">*</span>
                  </label>
                  <input
                    name="town"
                    onChange={formik.handleChange}
                    value={formik.values.town}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Enter your town"
                  />
                  {formik.touched.town && formik.errors.town ? (
                    <small className="text-danger">{formik.errors.town}</small>
                  ) : null}
                </div>
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    required
                    label="Local Government"
                    name="localGovernment"
                    onClickOption={formik.handleChange}
                    value={formik.values.localGovernment}
                    // onBlur={handleBlurAddressChild}
                    placeholder="Select LGA"
                    options={lgas}
                    formik={formik}
                    errorMessage={returnLgaError({
                      stateError: returnInputErrorMessage<FormValues>(
                        formik,
                        "areaState"
                      ),
                      lgaError: returnInputErrorMessage<FormValues>(
                        formik,
                        "localGovernment"
                      ),
                    })}
                  />
                  {/* <label htmlFor="housenumber" className="label_text">
                    <span className="text-danger">*</span>
                  </label> */}
                  {/* <select
                    className="form-control border-dark"
                    style={{
                      padding: "13px",
                    }}
                  >
                    <option value=""></option>
                    {lgas.map((lga) => (
                      <option key={lga} value={lga}>
                        {lga}
                      </option>
                    ))}
                  </select> */}
                  {/* {formik.touched.localGovernment &&
                  formik.errors.localGovernment ? (
                    <small className="text-danger">
                      {formik.errors.localGovernment}
                    </small>
                  ) : null} */}
                  {/* <label htmlFor="housenumber" className="label_text">Area/State<span className="text-danger">*</span></label>
                                    <input name="areaState" onChange={formik.handleChange} value={formik.values.areaState} onBlur={handleBlurAddressChild} type="text" className="form-control bg-white border-dark" placeholder="Lagos"  />
                                    {formik.touched.areaState && formik.errors.areaState ? <small className="text-danger">{formik.errors.areaState}</small> : null} */}
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mb-4">
            <label htmlFor="address" className="label_text">
              Enter Full Address<span className="text-danger">*</span>
            </label>
            <input
              name="address"
              onChange={formik.handleChange}
              value={formik.values.address}
              className="form-control sec border-dark"
              type="text"
              id="address"
              placeholder="No 12 Bode Thomas Masha round about Lagos"
              readOnly
            />
            {formik.touched.address && formik.errors.address ? (
              <small className="text-danger">{formik.errors.address}</small>
            ) : null}
          </div>
          <label
            htmlFor="residentialaddress"
            className="label_text my-2 mt-4 font-weight-bold"
            style={{ display: "block", textAlign: "center" }}
          >
            <b>Other Information</b>
          </label>
          <div className="form-group mb-4">
            <label htmlFor="nextofkin" className="label_text">
              Name of next of kin<span className="text-danger">*</span>
            </label>
            <input
              name="nextOfKin"
              onChange={formik.handleChange}
              value={formik.values.nextOfKin}
              className="form-control border-dark"
              type="text"
              id="name"
              placeholder="Enter name of next of kin"
            />
            {formik.touched.nextOfKin && formik.errors.nextOfKin ? (
              <small className="text-danger">{formik.errors.nextOfKin}</small>
            ) : null}
          </div>
          <div className="row d-flex mt-3 mb-4">
            <div className="col-lg-6 form-group">
              <CustomDropdown
                label="Relationship to Next Of Kin"
                required
                onClickOption={formik.handleChange}
                name="relationshipOfNextOfKin"
                value={formik.values.relationshipOfNextOfKin}
                options={nextOfKinRelationships}
                errorMessage={returnInputErrorMessage<FormValues>(
                  formik,
                  "relationshipOfNextOfKin"
                )}
                formik={formik}
              />
            </div>

            <div className="col-lg-6 form-group">
              <CustomDropdown
                required
                label="Religion"
                name="religion"
                onClickOption={formik.handleChange}
                value={getSelectedReligion(Number(formik.values.religion))}
                options={religions}
                labelKey="religion"
                valueKey="id"
                placeholder="Select religion"
                errorMessage={returnInputErrorMessage<FormValues>(
                  formik,
                  "religion"
                )}
                formik={formik}
              />
            </div>
          </div>

          <div className=" row d-flex form-group mb-4">
            <div className="col-lg-6">
              <CustomDropdown
                required
                label="Self employment information"
                name="selfEmployementInformation"
                onClickOption={formik.handleChange}
                value={getSelectedEmployment(
                  formik.values.selfEmployementInformation
                )}
                onBlur={formik.handleBlur}
                options={employmentInfo}
                labelKey="name"
                valueKey="id"
                placeholder="Select employment information"
                formik={formik}
                errorMessage={returnInputErrorMessage<FormValues>(
                  formik,
                  "selfEmployementInformation"
                )}
              />
              {/* <label htmlFor="employment" className="label_text">
                <span className="text-danger">*</span>
              </label> */}
              {/* <select className="form-control border-dark bg-white" id="">
                <option value=""></option>
                {employmentInfos.map((employmentInfo: IEmploymentInfo) => {
                  return (
                    <option key={employmentInfo.id} value={employmentInfo.id}>
                      {employmentInfo.name}
                    </option>
                  );
                })}
              </select> */}
            </div>
            <div className="col-lg-6 mr-0">
              <CustomDropdown
                required
                label="Occupation"
                name="occupation"
                onClickOption={formik.handleChange}
                value={getSelectedOccupation(formik.values.occupation)}
                placeholder="Select occupation"
                options={occupations}
                labelKey="name"
                valueKey="id"
                errorMessage={returnInputErrorMessage<FormValues>(
                  formik,
                  "occupation"
                )}
                formik={formik}
              />
              {/* <label htmlFor="occupation" className="label_text">
                <span className="text-danger">*</span>
              </label> */}
              {/* <select className="form-control border-dark">
                <option value=""></option>
                {occupations.map((occupation: IOccupation) => {
                  return (
                    <option key={occupation.id} value={occupation.id}>
                      {occupation.name}
                    </option>
                  );
                })}
              </select> */}
              {/* {formik.touched.occupation && formik.errors.occupation ? (
                <small className="text-danger">
                  {formik.errors.occupation}
                </small>
              ) : null} */}
            </div>
          </div>

          <div className="row mb-2">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="socialMediaId" className="label_text">
                    Social media type
                  </label>
                  <select
                    name="socialMediaId"
                    onChange={formik.handleChange}
                    value={formik.values.socialMediaId}
                    className="form-control border-dark"
                    style={{ paddingTop: "12px", paddingBottom: "12px" }}
                  >
                    <option>--Choose one--</option>
                    {socialMediaPlatforms.map((socialMediaPlatform) => {
                      return (
                        <option
                          key={socialMediaPlatform.id}
                          value={socialMediaPlatform.id}
                        >
                          {socialMediaPlatform.name}
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.socialMediaId &&
                  formik.errors.socialMediaId ? (
                    <small className="text-danger">
                      {formik.errors.socialMediaId}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="socialMediaHandle" className="label_text">
                    Enter social media link/handle
                  </label>
                  <input
                    name="socialMediaHandle"
                    onChange={formik.handleChange}
                    value={formik.values.socialMediaHandle}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="@john_doe"
                  />
                  {formik.touched.socialMediaHandle &&
                  formik.errors.socialMediaHandle ? (
                    <small className="text-danger">
                      {formik.errors.socialMediaHandle}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-2 align-items-end">
            <div className="col-lg-6 form-group">
              <CustomDropdown
                required
                label="Branch of Domiciliation"
                name="branchOfDomiciliation"
                onClickOption={formik.handleChange}
                value={getSelectedBranch(
                  `${formik.values.branchOfDomiciliation}`
                )}
                placeholder="Select branch"
                options={branches}
                labelKey="branch"
                valueKey="brancH_CODE"
                formik={formik}
                errorMessage={returnInputErrorMessage<FormValues>(
                  formik,
                  "branchOfDomiciliation"
                )}
              />
              {/* <label htmlFor="religion" className="label_text">
                <span className="text-danger">*</span>
              </label> */}
              {/* <select
                className="form-control border-dark"
                style={{
                  padding: "13px",
                }}
              >
                <option value=""></option>
                {branchData?.map((item: IBranch) => {
                  return (
                    <option key={item?.id} value={item?.brancH_CODE}>
                      {item?.branch}
                    </option>
                  );
                })}
              </select> */}
              {/* {formik.touched.branchOfDomiciliation &&
              formik.errors.branchOfDomiciliation ? (
                <small className="text-danger">
                  {formik.errors.branchOfDomiciliation}
                </small>
              ) : null} */}
            </div>
            <div className="form-group col-lg-6">
              <label htmlFor="refferalcode" className="label_text">
                DAO/Referral code(optional)
              </label>
              <input
                name="referralCode"
                onChange={formik.handleChange}
                value={formik.values.referralCode}
                className="form-control border-dark"
                type="text"
                id="name"
                placeholder="Enter referral code"
              />
            </div>
          </div>
          <label
            htmlFor="residentialaddress"
            className="label_text my-2 mt-4 font-weight-bold"
            style={{ display: "block", textAlign: "center" }}
          >
            {/* <b>Other Information</b> */}
          </label>

          <div className="form-group">
            {/* <label htmlFor="idcardtype" className="label_text">Select identity card type</label>

                    <ul className="nav nav-pills identity-tab mb-3 nav-fill" id="pills-tab" role="tablist">
                        {meansOfIdentification.map((identification:IMeansOfIdentification) => {
                            return(
                                <li className="nav-item" key={identification.id} onClick={() => handleSetIdCardType(identification.id)}>
                                    <a className={`nav-link text-nowrap pl-0 pt-2 
                                        ${storedUserDataIdCard ? identification.id == storedUserDataIdCard ? "active" : ""  :  identification.id == 1 ? "active" : ""}`
                                    } 
                                        id="pills-int-tab" data-toggle="pill"
                                        href="#pills-int" role="tab" aria-controls="pills-int" aria-selected="true">{identification.text}</a>
                                </li>
                            )
                        })}
                    </ul> */}
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane show fade active"
                id="pills-int"
                role="tabpanel"
                aria-labelledby="pills-int-tab"
              >
                <div className="row mb-4">
                  {/* <div className="col-md-6">
                    <div className="form-group">
                      <label
                        htmlFor="nextofkin"
                        className="label_text mb-2"
                        data-bs-toggle="modal"
                        data-bs-target="#idCardSampleModal"
                      >
                        National ID Card
                        <i className="bx bxs-info-circle cursor-pointer"></i>
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        name="idCardNumber"
                        onChange={formik.handleChange}
                        value={formik.values.idCardNumber}
                        className="form-control border-dark"
                        type="text"
                        id="name"
                        placeholder="Enter ID card number"
                      />
                    </div>
                    {formik.touched.idCardNumber &&
                    formik.errors.idCardNumber ? (
                      <small className="text-danger">
                        {formik.errors.idCardNumber}
                      </small>
                    ) : null}
                  </div> */}
                  <div className="col-md-3">
                    {/* <div className="form-group identity">
                      <label htmlFor="issuedate" className="label_text mb-2">
                        Issue Date
                      </label>
                      <input
                        name="issueDate"
                        max={todaysDate}
                        onChange={formik.handleChange}
                        value={formik.values.issueDate}
                        type="date"
                        className="form-control border-dark bg-white"
                        placeholder="dd/mm/yyyy"
                      />
                    </div> */}
                    {/* {formik.touched.issueDate && formik.errors.issueDate ? <small className="text-danger">{formik.errors.issueDate}</small> : null} */}
                  </div>

                  {/* {(idCardtype == 2 || idCardtype == 4) && (
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="expirydate" className="label_text mb-2">
                          Expiry Date
                        </label>
                        <input
                          name="expiryDate"
                          min={todaysDate}
                          onChange={formik.handleChange}
                          value={formik.values.expiryDate}
                          type="date"
                          className="form-control border-dark bg-white"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                      {formik.touched.expiryDate && formik.errors.expiryDate ? (
                        <small className="text-danger">
                          {formik.errors.expiryDate}
                        </small>
                      ) : null}
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>

          <OtpDialogModal
            openModal={ninModalOpen}
            closeModal={() => setNinModalOpen(false)}
            routeTo="document-upload"
          />

          <div className="d-flex justify-content-end mt-4">
            <button
              onClick={() => {
                goToStep("bvn-validation");
              }}
              style={{ marginRight: "10px" }}
              className="btn btn-outline-gold mr-3 btn-filled-white"
            >
              Previous
            </button>
            {updating ? (
              <div className="spinner-border text-gold" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button
                onClick={() => {}}
                disabled={!formik?.isValid || !formik.dirty}
                type="submit"
                className="btn btn-filled-red"
              >
                Proceed
              </button>
            )}
          </div>
        </div>
      </form>

      {/*  */}
      <div
        className="modal fade"
        id="idCardSampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <IdCardSample idCardType={idCardtype} />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
    </div>
  );
}

export default UpdateDetailMobiciliaryCurrentDialog;
